import React from 'react'

export default function EmbedVimeo ({ vimeoID, ...props }) {
  return (
    <iframe title='vimeo player' src={'https://player.vimeo.com/video/' + vimeoID} width='640' height='360' frameborder='0' allow='autoplay; fullscreen' allowfullscreen {...props} />
  )
}
